import * as React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  titleRoot: {
    display: "flex",
    justifyContent: "space-between;",
    paddingBottom: "12px",
    paddingTop: "12px",
    background: theme.palette.secondary.main,
    paddingRight: "5px",
  },
  title: {
    paddingBottom: 0,
    paddingTop: 0,
    fontSize: "1.1rem",
    fontWeight: 300,
    paddingLeft: "15px",
    color: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      padding: "0px 0px 0px 10px",
    },
  },
  closeIcon: {
    color: theme.palette.background.paper,
  },
}));

export default function MaxWidthDialog(props) {
  const classes = useStyles();

  const handleOnClose = () => {
    props.close();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={props.width ? props.width : "sm"}
        open={props.open}
        onClose={handleOnClose}
      >
        <Box component="span" className={classes.titleRoot}>
          <DialogTitle className={classes.title}>{props.title}</DialogTitle>
          <IconButton
            aria-label="close"
            sx={{ pb: 0, pt: 0, pl: "10px" }}
            onClick={handleOnClose}
          >
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Box>
        <DialogContent>{props.children}</DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
